import { AxiosHeaders, AxiosRequestConfig, AxiosResponse, Method } from 'axios'
import axiosClient, { getUser } from './interceptor.client'

class Client {
  get<T>(path: string, params?: any): Promise<T> {
    return axiosClient.get<any, T, any>(path, {
      params,
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
    })
  }

  getBlob<T>(path: string, params?: any): Promise<T> {
    return axiosClient.get<any, T, any>(path, {
      responseType: 'blob',
      params,
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
    })
  }

  post<T>(path: string, body?: any): Promise<T> {
    return axiosClient.post<any, T, T>(path, body, {
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
    })
  }

  put<T>(path: string, body?: any): Promise<T> {
    return axiosClient.put<any, T, T>(path, body, {
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
    })
  }

  delete<T>(path: string, body?: any): Promise<T> {
    return axiosClient.delete<any, T, T>(path, {
      data: body,
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
    })
  }

  request<T>(
    url: string,
    method: Method,
    data?: any,
    headers?: AxiosHeaders,
    params?: any,
  ): Promise<AxiosResponse<T, any>> {
    const config: AxiosRequestConfig = {
      url,
      method,
      data,
      headers: {
        Authorization: `Bearer ${getUser()?.access_token}`,
      },
      params,
    }

    return axiosClient.request<T>(config)
  }
}

export default new Client()
